import React from 'react';
import { SkeletonBlock, SkeletonText } from '@zapier/design-system';
import styled from '@emotion/styled';
import { mediaQueries } from 'components/mediaQueries';

const SkeletonCard = () => {
  return (
    <CardWrapper>
      <SkeletonBlock width="100%" height={120} />
      <TextWrapper>
        <SkeletonText lines={1} size="body" width="100%" />
        <SkeletonText lines={1} size="heading" width="100%" />
      </TextWrapper>
    </CardWrapper>
  );
};

export const MiniArticleCardsSkeletons = () => {
  return (
    <Wrapper>
      <SkeletonCard />
      <SkeletonCard />
      <SkeletonCard />
      <SkeletonCard />
      <SkeletonCard />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: grid;
  grid-row-gap: 10px;
  width: 100%;
  ${mediaQueries.tablet} {
    grid-row-gap: 15px;
  }
  ${mediaQueries.desktop} {
    grid-template-columns: repeat(5, 1fr);
    grid-column-gap: 20px;
    width: 1200px;
  }
`;

const CardWrapper = styled.div`
  display: grid;
  height: 135px; // This matches the image height on MiniArticleCard
  grid-template-columns: 135px auto;
  grid-column-gap: 10px;
  ${mediaQueries.tablet} {
    height: 126px; // This matches the image height on MiniArticleCard
    grid-column-gap: 40px;
    grid-template-columns: 224px auto;
  }
  ${mediaQueries.desktop} {
    height: 100%;
    grid-row-gap: 15px;
    grid-template-columns: 1fr;
  }
`;

const TextWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 10px;
`;
